import { api, setConfig, RESET_SUCCESS_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const resetPassword = (data: PropertyType): Promise<string | void> =>
	api.post('/reset', mapEntityToApi(data), setConfig(data)).then(() => {
		return RESET_SUCCESS_MESSAGE;
	});
